import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Monitor, ArrowLeft } from 'lucide-react';

/**
 * Wrap "desktop-only" pages — on mobile shows a friendly placeholder,
 * on tablet/desktop renders children normally.
 *
 * Use: <MobilePageGuard title="Beállítások"><Settings/></MobilePageGuard>
 */
export default function MobilePageGuard({ title, children, hint }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="hidden md:block">{children}</div>
      <div
        className="md:hidden flex flex-col items-center justify-center text-center px-6 py-12"
        data-testid="mobile-desktop-only"
        style={{ minHeight: '60vh' }}
      >
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
          style={{
            background: 'linear-gradient(135deg, var(--accent-copper-soft, #FEF3E8), var(--accent-copper-soft, #FEF3E8))',
            color: 'var(--accent-copper)',
          }}
        >
          <Monitor size={32} strokeWidth={1.75} />
        </div>
        <h2 className="font-heading text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
          {title || 'Ez az oldal asztali nézetre van optimalizálva'}
        </h2>
        <p className="text-sm max-w-sm mb-6" style={{ color: 'var(--text-secondary)' }}>
          {hint || 'Ezt a funkciót számítógépen érdemes használni — ott minden mező és beállítás kényelmesen elfér.'}
        </p>
        <button
          onClick={() => navigate(-1)}
          data-testid="mobile-guard-back"
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all"
          style={{
            backgroundColor: 'var(--accent-copper)',
            color: 'var(--accent-copper-fg, #FFFFFF)',
            boxShadow: '0 2px 8px -2px rgba(217, 112, 54, 0.4)',
          }}
        >
          <ArrowLeft size={16} /> Vissza
        </button>
      </div>
    </>
  );
}
